import React from "react";
import {
  Card,
  Row,
  Col,
} from "react-bootstrap";


export function AchievementCards({achievements}){
  
  return (
    <Row xs={1} md={2} lg={3} className="g-4">
      {achievements.map((achievement, idx) => (
        <Col key={idx} className="compact-column">
          <Card className="achievement-card">
            <Card.Body>
              <Card.Title>
                {achievement.title}
              </Card.Title>
              <Card.Subtitle className="mb-2" style={{ color: "#E3E5DE" }}>
                <div>
                  <div>{achievement.subtitle}</div>
                  <div>{achievement.competition}</div>
                  <div
                    className="impact-line"
                    style={{
                      width: "100%",
                      height: "2px",
                      margin: "8px 0 12px 0",
                      display: "inline-block",
                    }}
                  />
                </div>
              </Card.Subtitle>
              <Card.Text style={{ fontWeight: 300, fontSize: "0.95rem" }}>{achievement.description}</Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};